(function(){
  'use strict';
  if(window.__MXP_REPAIR_CHECKOUT_COMPACT_V2__)return;
  window.__MXP_REPAIR_CHECKOUT_COMPACT_V2__=true;

  var nativeFetch=window.fetch.bind(window);
  var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  if(base.charAt(base.length-1)!=='/')base+='/';
  var privateMap={
    'Tarif':'_mxp_tarif',
    'Mode de prise en charge':'_mxp_shipping',
    'Prise en charge':'_mxp_shipping',
    'IMEI':'_mxp_imei',
    'Précisions':'_mxp_notes',
    'Precisions':'_mxp_notes',
    'Description':'_mxp_notes',
    'Description de la panne':'_mxp_notes'
  };
  var repairTxn={rev:'',groupId:'',draftId:'',newKeys:[]};

  function norm(value){
    var out=String(value||'').trim().toLowerCase();
    try{out=out.normalize('NFD').replace(/[\u0300-\u036f]/g,'')}catch(e){}
    return out.replace(/[\u2019\u2018]/g,"'").replace(/\s+/g,' ');
  }

  function propertyValue(props,names){
    if(!props)return '';
    var wanted=names.map(norm);
    if(Array.isArray(props)){
      for(var a=0;a<props.length;a++){
        var row=props[a],rk=Array.isArray(row)?row[0]:(row&&row.name),rv=Array.isArray(row)?row[1]:(row&&row.value);
        if(wanted.indexOf(norm(rk))>-1&&rv!==undefined&&rv!==null&&String(rv).trim()!=='')return String(rv);
      }
      return '';
    }
    var keys=Object.keys(props);
    for(var i=0;i<keys.length;i++){
      if(wanted.indexOf(norm(keys[i]))>-1&&props[keys[i]]!==undefined&&props[keys[i]]!==null&&String(props[keys[i]]).trim()!=='')return String(props[keys[i]]);
    }
    return '';
  }

  function isRepairProperties(props){
    return !!propertyValue(props,['Modèle','Modele'])&&!!propertyValue(props,['Réparation','Reparation','Panne']);
  }

  function compactProperties(props){
    if(!props||typeof props!=='object'||Array.isArray(props)||!isRepairProperties(props))return props;
    var next=Object.assign({},props);
    Object.keys(privateMap).forEach(function(publicKey){
      if(next[publicKey]===undefined||next[publicKey]===null||String(next[publicKey]).trim()==='')return;
      var privateKey=privateMap[publicKey];
      if(next[privateKey]===undefined||next[privateKey]===null||String(next[privateKey]).trim()==='')next[privateKey]=next[publicKey];
      delete next[publicKey];
    });
    return next;
  }

  function transformPayload(payload){
    if(!payload||typeof payload!=='object')return payload;
    if(Array.isArray(payload.items)){
      payload.items=payload.items.map(function(item){
        if(!item||typeof item!=='object')return item;
        var copy=Object.assign({},item);
        if(copy.properties)copy.properties=compactProperties(copy.properties);
        return copy;
      });
      return payload;
    }
    if(payload.properties)payload.properties=compactProperties(payload.properties);
    return payload;
  }

  function pathname(input){
    var url='';
    try{url=typeof input==='string'?input:(input&&input.url)||String(input||'')}catch(e){}
    try{return new URL(url,location.origin).pathname}catch(e){return String(url||'')}
  }
  function isCartAdd(input){return /\/cart\/add(?:\.js)?\/?$/.test(pathname(input))}
  function isCartUpdate(input){return /\/cart\/update(?:\.js)?\/?$/.test(pathname(input))}
  function isMailinPage(){return location.pathname.replace(/\/$/,'')==='/pages/envoi-reparation'}

  function jsonBody(init){
    if(!init||typeof init.body!=='string')return null;
    var contentType='';
    try{
      var headers=new Headers(init.headers||{});
      contentType=headers.get('Content-Type')||headers.get('content-type')||'';
    }catch(e){}
    if(contentType.toLowerCase().indexOf('application/json')===-1)return null;
    try{return JSON.parse(init.body)}catch(e){return null}
  }

  function rememberRepairRequest(payload){
    var items=payload&&Array.isArray(payload.items)?payload.items:[];
    var repair=items.find(function(item){return item&&isRepairProperties(item.properties)});
    if(!repair)return false;
    var props=repair.properties||{};
    repairTxn.rev=propertyValue(props,['_mxp_repair_edit_rev','mxp_repair_edit_rev']);
    repairTxn.groupId=propertyValue(props,['_mxp_repair_group_id','mxp_repair_group_id']);
    repairTxn.draftId=propertyValue(props,['_mxp_repair_draft_id','mxp_repair_draft_id']);
    repairTxn.newKeys=[];
    return true;
  }

  function rememberAddedKeys(response){
    try{
      response.clone().json().then(function(data){
        var rows=Array.isArray(data&&data.items)?data.items:(data&&data.key?[data]:[]);
        repairTxn.newKeys=rows.map(function(item){return String(item&&item.key||'')}).filter(Boolean);
      }).catch(function(){});
    }catch(e){}
  }

  function onlyRemovals(payload){
    if(!payload||!payload.updates||typeof payload.updates!=='object')return false;
    var keys=Object.keys(payload.updates);
    return keys.length>0&&keys.every(function(key){return Number(payload.updates[key])===0});
  }

  function unique(list){
    var seen={};
    return list.filter(function(value){value=String(value||'');if(!value||seen[value])return false;seen[value]=true;return true});
  }

  function oldRepairKeys(cart,requested){
    var items=cart&&Array.isArray(cart.items)?cart.items:[];
    var current={};
    items.forEach(function(item){var key=String(item&&item.key||'');if(key)current[key]=true});
    var keys=Object.keys(requested||{}).filter(function(key){return current[key]});
    var newKeyMap={};
    repairTxn.newKeys.forEach(function(key){newKeyMap[String(key)]=true});
    var fallback=items.filter(function(item){
      var key=String(item&&item.key||'');
      if(!key||newKeyMap[key])return false;
      var props=item&&item.properties||{};
      var rev=propertyValue(props,['_mxp_repair_edit_rev','mxp_repair_edit_rev']);
      if(repairTxn.rev&&rev===repairTxn.rev)return false;
      var groupId=propertyValue(props,['_mxp_repair_group_id','mxp_repair_group_id']);
      var draftId=propertyValue(props,['_mxp_repair_draft_id','mxp_repair_draft_id']);
      if(repairTxn.groupId&&groupId===repairTxn.groupId)return true;
      if(repairTxn.draftId&&draftId===repairTxn.draftId)return true;
      return false;
    }).map(function(item){return String(item.key||'')});
    return unique(keys.concat(fallback));
  }

  function successfulCartResponse(cart){
    return new Response(JSON.stringify(cart||{}),{status:200,headers:{'Content-Type':'application/json; charset=utf-8'}});
  }

  async function safeRepairUpdate(input,init,payload){
    var cartResponse=await nativeFetch(base+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!cartResponse.ok)return nativeFetch(input,init);
    var cart=await cartResponse.json();
    var keys=oldRepairKeys(cart,payload.updates);
    if(!keys.length)return successfulCartResponse(cart);
    var updates={};
    keys.forEach(function(key){updates[key]=0});
    var nextInit=Object.assign({},init,{body:JSON.stringify(Object.assign({},payload,{updates:updates}))});
    return nativeFetch(input,nextInit);
  }

  window.fetch=function(input,init){
    var payload=jsonBody(init);

    if(isCartAdd(input)&&payload){
      var transformed=transformPayload(payload);
      var isRepairAdd=isMailinPage()&&rememberRepairRequest(transformed);
      var nextInit=Object.assign({},init,{body:JSON.stringify(transformed)});
      var request=nativeFetch(input,nextInit);
      if(isRepairAdd){
        return request.then(function(response){rememberAddedKeys(response);return response});
      }
      return request;
    }

    if(isMailinPage()&&repairTxn.rev&&isCartUpdate(input)&&payload&&onlyRemovals(payload)){
      return safeRepairUpdate(input,init,payload).catch(function(){return nativeFetch(input,init)});
    }

    return nativeFetch(input,init);
  };
})();